import {
  ChangeDetectionStrategy, Component, EventEmitter,
  Input, OnChanges, Output, SimpleChanges, signal,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { MeetingDetailTableComponent } from '../../../../shared/components/meeting-detail-table/meeting-detail-table.component';
import { TimezoneSelectComponent } from '../../../../shared/components/timezone-select/timezone-select.component';
import { RescheduleDetails } from '../../models/pcheck.model';
import { browserTimezone, isIsoUtc } from '../../helpers/booking-timezone';

@Component({
  selector: 'app-reschedule-card',
  standalone: true,
  imports: [CommonModule, MeetingDetailTableComponent, TimezoneSelectComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './reschedule-card.component.html',
  styleUrls: ['./reschedule-card.component.scss'],
})
export class RescheduleCardComponent implements OnChanges {
  @Input() rescheduleUrl!: string;
  @Input() details!: RescheduleDetails;
  /** True after the user clicks "I've Rescheduled". */
  @Input() confirmed = false;

  @Output() rescheduled = new EventEmitter<void>();

  // Default to the timezone the user selected when booking (PST by default in
  // the slot picker), falling back to the browser's local zone for legacy
  // meetings that have no recorded timezone. The user can still switch zones.
  readonly displayTz = signal(browserTimezone());

  /** Show the timezone picker only when the backend sent a UTC ISO time
   *  (regular pcheck). Legacy pre-formatted strings (IMPACT) render as-is. */
  get showTzPicker(): boolean { return isIsoUtc(this.details?.start_time); }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['details'] && this.details?.timezone) {
      this.displayTz.set(this.details.timezone);
    }
  }

  onTimezoneChange(tz: string): void { this.displayTz.set(tz); }

  onConfirm(): void { this.rescheduled.emit(); }
}
